import _ from "lodash";

export const buildStepStylesheet = (builder, device, cta, variant, step) => {
    let background_image;
    if (
      variant.options["background-image"] &&
      variant.options["background-image"] !== "none"
    ) {
      background_image = variant.options["background-image"]
        .replace("url(", "")
        .replace(")", "");
    }

    // prettier-ignore
    const desktopStyles =
`#cta_${cta.id} .cf-cta-container-background[data-variant-id="${variant.id}"] {
  ${background_image ? "background-image: url(" + background_image + ") !important;" : ''}
}

#cta_${cta.id} .cf-cta-container-overlay[data-variant-id="${variant.id}"] {
  ${variant.options["background-color"] ? 'background: ' + variant.options["background-color"] + '!important;' : ''}
  ${_.isNil(variant.options["background-opacity"]) == false ? 'opacity: ' + variant.options["background-opacity"] + '!important;' : ''}
}
`;

    // prettier-ignore
    const mobileStyles =
`/* mobile styles */
#cta_${cta.id} .cf-cta-container-background[data-variant-id="${variant.id}"] {
  ${_.isNil(variant.options['background-position-mobile']) == false ? 'background-position: ' + variant.options['background-position-mobile'].replace('-', ' ') + ' !important' : ''};
  ${_.isNil(variant.options['background-size-mobile']) == false ? 'background-size: ' + (variant.options['background-size-mobile'] !== 'expand-height' ? variant.options['background-size-mobile'] : 'auto 100%') + ' !important' : ''};
}`;

    if (builder !== true) {
      return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
    } else {
      if (device == "desktop") {
        return desktopStyles;
      } else {
        return desktopStyles + mobileStyles;
      }
    }
};
